// Start Call Mdoal (StartCallModal/StartCallModal.js)
export const START_VIDEO_DATA_ATTR = { dataAttrs: { 'data-lsqa': 'start-video' } };
export const START_AUDIO_DATA_ATTR = { dataAttrs: { 'data-lsqa': 'start-audio' } };

// Call Footer (InCall/CallFooter.js)
export const MUTE_AUDIO_DATA_ATTR = { dataAttrs: { 'data-lsqa': 'mute-audio' } };
export const MUTE_AUDIO_BUTTON = { dataAttrs: { 'data-lsqa': 'mute-audio-button' } };
export const MUTE_AUDIO = { 'data-lsqa': 'mute-audio' };
export const MUTE_VIDEO = { 'data-lsqa': 'mute-video' };
export const START_RECORDING = { 'data-lsqa': 'start-recording' };
export const STOP_RECORDING = { 'data-lsqa': 'stop-recording' };
export const END_CALL = { 'data-lsqa': 'end-call' };

// Presentation (CallControls/PresentationButton.js)
export const START_PRESENTATION_BUTTON = { 'data-lsqa': 'start-presentation' };
export const STOP_PRESENTATION_BUTTON = { 'data-lsqa': 'stop-presentation' };

// Presentation (CallControls/PresentationButton.js)
export const RAISE_HAND_BUTTON = { 'data-testid': 'btnRaiseHand' };
export const LOWER_HAND_BUTTON = { 'data-testid': 'btnLowerHand' };

// Activity Feed (ActivityFeed/ActivityFeed.js)
export const RECENT_ACTIVITY = { 'data-lsqa': 'recent-activity' };
